import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  firstName: Yup.string().max(255).required('First Name is required'),
  lastName: Yup.string().max(255).required('Last Name is required'),
  email: Yup.string()
    .email('Must be a valid email')
    .max(255)
    .required('Email is required'),
  address: Yup.string(),
  city: Yup.string()
    .nullable()
    .matches(/^[A-Za-z\s]+$/, 'Invalid city name'),
  state: Yup.string()
    .nullable()
    .matches(/^[A-Za-z\s]+$/, 'Invalid state name'),
  country: Yup.string()
    .nullable()
    .matches(/^[A-Za-z\s]+$/, 'Invalid country name'),
  linked_in_url: Yup.string().url('Invalid URL format'),
  current_password: Yup.string().required('Current password is required'),
  password: Yup.string()
    .required('New password is required')
    .min(8, 'Password must be at least 8 characters')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
      'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character'
    ),
  passwordConfirmation: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref('password'), null], 'Passwords must match'),
  languages: Yup.array().of(
    Yup.object().shape({
      name: Yup.string(),
      speaking: Yup.string().test(
        'speaking-required',
        'Required',
        function (value) {
          return !!this.parent.name ? !!value : true;
        }
      ),
      writing: Yup.string().test(
        'writing-required',
        'Required',
        function (value) {
          return !!this.parent.name ? !!value : true;
        }
      ),
    })
  ),
});

export const passwordValidationSchema = Yup.object().shape({
  current_password: Yup.string().required('Current password is required'),
  password: Yup.string()
    .required('New password is required')
    .min(8, 'Password must be at least 8 characters')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
      'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character'
    ),
  confirmPassword: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref('password'), null], 'Passwords must match'),
});

export const validationSchemaProfile = Yup.object().shape({
  first_name: Yup.string()
    .trim()
    .required('First name is required')
    .min(2, 'First name must be at least 2 characters long')
    .max(50, 'First name must not exceed 50 characters'),
  last_name: Yup.string()
    .trim()
    .min(2, 'Last name must be at least 2 characters long')
    .max(50, 'Last name must not exceed 50 characters'),
  email: Yup.string()
    .email('Invalid email format')
    .required('Email is required'),

  birth_date: Yup.date()
    .nullable()
    .max(
      new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
      'Must be at least 18 years old'
    ),
  organization_name: Yup.string()
    .trim()
    .min(2, 'Organization name must be at least 2 characters long')
    .max(50, 'Organization name must not exceed 50 characters'),
});
